import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  Fade,
  Grid,
  IconButton,
  Paper,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import "../styles/components/PaperBasket.scss";
import Loader from "./Loader";
import ImageGallery from "react-image-gallery";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
function PaperBasket({
  desc,
  quantity,
  PastOrders,
  Basket,
  image,
  index,
  handleDelete,
  id,
  imageLoader,
  delLoading,
  order_by,
  status,
}) {
  const [showGallery, setShowGallery] = useState(false);
  const [imagesArr, setImagesArr] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const handleCloseGallery = () => {
    setShowGallery(false);
  };

  const handleOpenGallery = (imageIndex) => {
    setShowGallery(true);
    setStartIndex(imageIndex);
  };
  useEffect(() => {
    setImagesArr([
      {
        original: image,
        thumbnail: image,
      },
    ]);
  }, [image?.length]);
  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
      padding: "0px",
    },
  });
  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });
  return (
    <div key={`${index} ${index}`} className="paperBasketDiv">
      <Dialog
        onClose={handleCloseGallery}
        aria-labelledby="simple-dialog-title"
        open={showGallery}
        maxWidth="md"
        fullWidth
        className="modal"
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleCloseGallery}
        />
        <Fade in={showGallery}>
          <ImageGallery
            items={imagesArr}
            showPlayButton={false}
            startIndex={0}
          />
        </Fade>
      </Dialog>

      <Grid className="PaperBasket">
        <Paper className="paper">
          <div className={Basket ? "contentBasket" : "content"}>
            {Basket ? (
              <div className="btnDiv">
                <Button
                  onClick={() => handleDelete(id, index)}
                  variant="contained"
                  disabled={delLoading}
                >
                  X
                </Button>
              </div>
            ) : null}
            <Box p={1} m={1} className="imgBox">
              {imageLoader ? (
                <Loader />
              ) : (
                <img
                  src={image}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpenGallery(index)}
                />
              )}
              <Box className="descDiv">
                <input
                  type="number"
                  className="numberfield"
                  name="quantity"
                  placeholder="Quantity"
                  min="0"
                  value={quantity}
                  disabled={true}
                />
                <textarea
                  placeholder="Description (Optional)"
                  value={desc}
                  disabled={true}
                  className="TextArea"
                />
                {PastOrders ? (
                  <>
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        variant={
                          window.screen.width >= 959 ? "overline" : "caption"
                        }
                        display="block"
                        gutterBottom
                        style={{ textTransform: "capitalize" }}
                      >
                        {status} By: {order_by}
                      </Typography>
                    </Box>
                  </>
                ) : null}
              </Box>
            </Box>
          </div>
        </Paper>
      </Grid>
    </div>
  );
}

export default PaperBasket;
